import React, { useState } from 'react';
import axios from 'axios';
import { EyeIcon, Logo, EyeOffIcon } from '../components/Icons'; // Assuming this path is correct
import './loginPage.css';

interface LoginPageProps {
  onLoginSuccess: (token: string, user: { id: number; email: string; is_active: boolean }) => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // This is the correct way to get the API URL
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Please enter both email and password.');
      return;
    }
    setIsLoading(true);

    // --- THIS IS THE CRITICAL FIX ---
    // The backend's OAuth2 form expects 'x-www-form-urlencoded' data, not JSON.
    // We use URLSearchParams to build this format.
    const formData = new URLSearchParams();
    formData.append('username', email); // The form field must be 'username'
    formData.append('password', password);

    try {
      // 1. Send the login request with the form data
      const response = await axios.post(`${API_BASE_URL}/api/login/token`, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      const accessToken = response.data.access_token;

      // 2. Now that we are logged in, fetch the user's details
      const userResponse = await axios.get(`${API_BASE_URL}/api/users/me`, {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      });

      // 3. Pass both the token and user details up to App.tsx
      onLoginSuccess(accessToken, userResponse.data);

    } catch (err: any) {
      if (axios.isAxiosError(err) && err.response) {
        if (err.response.status === 422) {
          setError('Invalid data format. Please contact support.'); // Should not happen with this fix
        } else if (err.response.status === 401) {
          setError(err.response.data.detail || 'Invalid email or password.');
        } else {
          setError('Login failed. Please try again later.');
        }
      } else {
        setError('Login failed. Please try again later.');
      }
      console.error('Login error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="login-card">
        <div className="header">
          <Logo />
          <h1>LORDS ERP</h1>
          <p>Welcome back! Please log in to your account.</p>
        </div>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              id="email"
              type="email"
              className="input-field"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="input-wrapper">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                className="input-field password-field"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isLoading}
              />
              <button
                type="button"
                className="toggle-password-btn"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
            
            {/* --- FIX for href="#" --- */}
            <button 
              type="button" 
              className="forgot-password"
              onClick={() => alert('Forgot password functionality to be added.')}
            >
              Forgot Password?
            </button>

          </div>
          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading && <div className="spinner"></div>}
            {isLoading ? 'Logging In...' : 'Log In'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;